export type Toast = {
  message: string
  color: 'danger' | 'warning' | 'success' | 'none'
}

export type ToastScope = 'page' | 'dialog'

export const useToast = (scope: ToastScope = 'page') => {
  const toasts = useState<Toast[]>(`toast:${scope}`, () => [])
  const hasToast = computed(() => toasts.value.length > 0)

  const popToast = () => {
    const toast = toasts.value[toasts.value.length - 1]
    toasts.value = toasts.value.slice(0, -1)

    return toast
  }

  return {
    addToast: (toast: Toast) => {
      // pushでは変更検知されない
      toasts.value = [...toasts.value, toast]
    },
    popToast,
    hasToast,
  }
}
